import { LoaderFunctionArgs, redirect } from "react-router";

export const CASE_DISPLAY_GROUP_DEFAULT_NAME = "Default";

export const caseDisplayGroupsLoader = async (args: LoaderFunctionArgs) => {
  const caseDisplayGroupName = args.params.caseDisplayGroupName;

  if (caseDisplayGroupName === undefined) {
    return redirect(CASE_DISPLAY_GROUP_DEFAULT_NAME);
  }

  return null;
};
